module["exports"] = [
  "北",
  "東",
  "西",
  "南",
  "新",
  "湖",
  "港"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ja/address/city_prefix.js
// module id = 754
// module chunks = 0